import { render, staticRenderFns } from "./RequestInstruction.vue?vue&type=template&id=ed9bc26e&lang=pug&"
import script from "./RequestInstruction.vue?vue&type=script&lang=js&"
export * from "./RequestInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports